;
(function(){
  var s=document.getElementById('bgSticky');
  if(s){var shown=false;function c(){var p=window.scrollY/(document.documentElement.scrollHeight-window.innerHeight);if(p>0.12&&!shown){s.classList.add('bg-sticky-visible');shown=true}}window.addEventListener('scroll',c,{passive:true});c()}
})();

;
(function(){
  var sticky = document.getElementById('om-sticky-bar');
  if (!sticky) return;
  var shown = false;
  function checkScroll() {
    var scrollPct = window.scrollY / (document.documentElement.scrollHeight - window.innerHeight);
    if (scrollPct > 0.20 && !shown) {
      sticky.classList.add('om-sticky--visible');
      shown = true;
    } else if (scrollPct <= 0.15 && shown) {
      sticky.classList.remove('om-sticky--visible');
      shown = false;
    }
  }
  window.addEventListener('scroll', checkScroll, { passive: true });
})();
